<template>
	<b-modal ref="modal" title="Osveži podatke" class="modal-primary" ok-title="Zaključi" cancel-title="Prekliči" @ok="onOkModal">
		<div v-show="showStep1" class="dUpload">
			<vue-dropzone ref="dzZalogaRenault" id="dropzoneZaloga" class="dzPopulateData renault" :include-styling="true" :options="usZalogaRenault" />
			<vue-dropzone ref="dzProdajaRenault" id="dropzoneProdaja" class="dzPopulateData renault" :include-styling="true" :options="usProdajaRenault" />
			<vue-dropzone ref="dzZalogaDacia" id="dropzoneZaloga" class="dzPopulateData dacia" :include-styling="true" :options="usZalogaDacia" />
			<vue-dropzone ref="dzProdajaDacia" id="dropzoneProdaja" class="dzPopulateData dacia" :include-styling="true" :options="usProdajaDacia" />
		</div>
		<div v-show="showStep2" class="dProcessing">
			Obdelava podatkov ...
			<b-progress :value="100" variant="success" striped :animated="animate" class="mb-2"></b-progress>
		</div>
		<div v-show="showStep3" v-html="uploadResultMessage"></div>
	</b-modal>
</template>
<script>
import vue2Dropzone from 'vue2-dropzone';
import service from '@/service';
import firebase from 'firebase';

const usDefaultValues = {
	url: process.env.API_BASE_URL + 'api/v1/upload',
	thumbnailWidth: 150,
	maxFilesize: 50,
	uploadMultiple: false,
	maxFiles: 1,
	addRemoveLinks: false,
	paramName: 'import_data',
	// acceptedFiles: ".jpeg,.jpg,.png,.gif,.JPEG,.JPG,.PNG,.GIF",
	dictRemoveFile: 'Odstrani datoteko',
	dictFileTooBig: 'Datoteka je prevelika',
	init: (event) => {
		console.log('DZ init');
	},
	uploadprogress: (file, progress, bytesSent, event) => {
		console.log('DZ uploadprogress');
		console.log(progress);
	}
};

export default {
	components: {
		vueDropzone: vue2Dropzone
	},
	methods: {
		showModal: function () {
			this.$refs.modal.show();
		},
		onOkModal: function (evt) {
			this.$refs.modal.hide();
			this.showStep1 = true;
			this.showStep2 = false;
			this.showStep3 = false;
			this.zalogaUploadedRenault = null;
			this.prodajaUploadedRenault = null;
			this.zalogaUploadedDacia = null;
			this.prodajaUploadedDacia = null;
			this.uploadResultMessage = '';
			this.$refs.dzZalogaRenault.removeAllFiles();
			this.$refs.dzProdajaRenault.removeAllFiles();
			this.$refs.dzZalogaDacia.removeAllFiles();
			this.$refs.dzProdajaDacia.removeAllFiles();
		},
		moveToProcessing: function () {
			if (this.zalogaUploadedRenault && this.prodajaUploadedRenault && this.zalogaUploadedDacia && this.prodajaUploadedDacia) {
				this.showStep1 = false;
				this.showStep2 = true;
				this.showStep3 = false;
				service.uvoziVozila(this.zalogaUploadedRenault, this.prodajaUploadedRenault, this.zalogaUploadedDacia, this.prodajaUploadedDacia)
					.then(response => {
						this.uploadResultMessage = 'Zaloga uspešno posodobljena. Najdenih je bilo <b>' + (response.data.renault.zaloga.total + response.data.dacia.zaloga.total) + '</b>, od tega <b>' + (response.data.renault.zaloga.new + response.data.dacia.zaloga.new) + '</b> novih.';
						this.uploadResultMessage += '<br /><br />';
						this.uploadResultMessage += 'Prodaja uspešno posodobljena. Najdenih je bilo <b>' + (response.data.renault.prodaja.total + response.data.dacia.prodaja.total) + '</b>, od tega <b>' + (response.data.renault.prodaja.new + response.data.dacia.prodaja.new) + '</b> novih.';
						this.showStep1 = false;
						this.showStep2 = false;
						this.showStep3 = true;
						this.$emit('data-updated');
					})
					.catch(error => {
						if (error) {
							console.log(error);
							this.uploadResultMessage = 'Napaka pri uvozu podatkov!';
							this.showStep1 = false;
							this.showStep2 = false;
							this.showStep3 = true;
						}
					});
			}
		},
		dzTemplate: function () {
			return `<div class="dz-preview dz-file-preview">
				<div class="dz-image">
					<div data-dz-thumbnail-bg></div>
				</div>
				<div class="dz-details">
					<div class="dz-filename"><span data-dz-name></span></div><br />(<div class="dz-size"><span data-dz-size></span></div>)
				</div>
				<div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>
				<div class="dz-error-message"><span data-dz-errormessage></span></div>
				<div class="dz-success-mark"><i class="fa fa-check"></i></div>
				<div class="dz-error-mark"><i class="fa fa-close"></i></div>
			</div>`;
		}
	},
	data: function () {
		return {
			showStep1: true,
			showStep2: false,
			showStep3: false,
			animate: true,
			zalogaUploadedRenault: null,
			prodajaUploadedRenault: null,
			zalogaUploadedDacia: null,
			prodajaUploadedDacia: null,
			uploadResultMessage: '',
			usZalogaRenault: {
				...usDefaultValues,
				previewTemplate: this.dzTemplate(),
				dictDefaultMessage: 'Izberi datoteko z zalogo<br /><b>Renault</b>',
				sending: (file, xhr, formData) => {
					console.log('DZ send');
					formData.append('import_type', 'zaloga');
					formData.append('import_make', 'renault');
				},
				error: (file, message, xhr) => {
					console.log('DZ error');
					console.log(message);
					if (file.previewElement) {
						let elem = file.previewElement.getElementsByClassName('dz-error-mark');
						elem[0].style.display = 'block';
					}
					this.zalogaUploadedRenault = null;
				},
				success: (file, response) => {
					console.log('DZ success');
					console.log(response);
					if (file.previewElement) {
						let elem = file.previewElement.getElementsByClassName('dz-success-mark');
						elem[0].style.display = 'block';
					}
					this.zalogaUploadedRenault = response.data.file;
					this.moveToProcessing();
				}
			},
			usProdajaRenault: {
				...usDefaultValues,
				previewTemplate: this.dzTemplate(),
				dictDefaultMessage: 'Izberi datoteko s prodajo<br /><b>Renault</b>',
				sending: (file, xhr, formData) => {
					console.log('DZ send');
					formData.append('import_type', 'prodaja');
					formData.append('import_make', 'renault');
				},
				error: (file, message, xhr) => {
					console.log('DZ error');
					console.log(message);
					if (file.previewElement) {
						let elem = file.previewElement.getElementsByClassName('dz-error-mark');
						elem[0].style.display = 'block';
					}
					this.prodajaUploadedRenault = null;
				},
				success: (file, response) => {
					console.log('DZ success');
					console.log(response);
					if (file.previewElement) {
						let elem = file.previewElement.getElementsByClassName('dz-success-mark');
						elem[0].style.display = 'block';
					}
					this.prodajaUploadedRenault = response.data.file;
					this.moveToProcessing();
				}
			},
			usZalogaDacia: {
				...usDefaultValues,
				previewTemplate: this.dzTemplate(),
				dictDefaultMessage: 'Izberi datoteko z zalogo<br /><b>Dacia</b>',
				sending: (file, xhr, formData) => {
					console.log('DZ send');
					formData.append('import_type', 'zaloga');
					formData.append('import_make', 'dacia');
				},
				error: (file, message, xhr) => {
					console.log('DZ error');
					console.log(message);
					if (file.previewElement) {
						let elem = file.previewElement.getElementsByClassName('dz-error-mark');
						elem[0].style.display = 'block';
					}
					this.zalogaUploadedDacia = null;
				},
				success: (file, response) => {
					console.log('DZ success');
					console.log(response);
					if (file.previewElement) {
						let elem = file.previewElement.getElementsByClassName('dz-success-mark');
						elem[0].style.display = 'block';
					}
					this.zalogaUploadedDacia = response.data.file;
					this.moveToProcessing();
				}
			},
			usProdajaDacia: {
				...usDefaultValues,
				previewTemplate: this.dzTemplate(),
				dictDefaultMessage: 'Izberi datoteko s prodajo<br /><b>Dacia</b>',
				sending: (file, xhr, formData) => {
					console.log('DZ send');
					formData.append('import_type', 'prodaja');
					formData.append('import_make', 'dacia');
				},
				error: (file, message, xhr) => {
					console.log('DZ error');
					console.log(message);
					if (file.previewElement) {
						let elem = file.previewElement.getElementsByClassName('dz-error-mark');
						elem[0].style.display = 'block';
					}
					this.prodajaUploadedDacia = null;
				},
				success: (file, response) => {
					console.log('DZ success');
					console.log(response);
					if (file.previewElement) {
						let elem = file.previewElement.getElementsByClassName('dz-success-mark');
						elem[0].style.display = 'block';
					}
					this.prodajaUploadedDacia = response.data.file;
					this.moveToProcessing();
				}
			}
		}
	},
	created () {
		let user = firebase.auth().currentUser;
		user.getIdToken().then((idToken) => {
			let headers = {
				'Authorization': 'Bearer ' + idToken
			};
			this.usZalogaRenault.headers = headers;
			this.usProdajaRenault.headers = headers;
			this.usZalogaDacia.headers = headers;
			this.usProdajaDacia.headers = headers;
		});
	}
}
</script>

<style>
.dUpload {
	text-align: center;
	vertical-align: middle;
}
.dProcessing {
	min-height: 80px;
	border:2px solid #e5e5e5;
	letter-spacing:.2px;
	color: #555555;
	padding: 20px;
	box-sizing: border-box;
	transition: background-color .2s linear;
}
	.dProcessing:hover {
		background-color:#f6f6f6;
	}
.dzPopulateData {
	min-height: 40px;
	width: 40%;
	border:2px solid #e5e5e5;
	letter-spacing:.2px;
	color: #555555;
	padding: 5px;
	margin: 10px;
	box-sizing: border-box;
	transition: background-color .2s linear;
	display: inline-block;
	vertical-align: middle;
}
	.dzPopulateData:hover {
		background-color:#f6f6f6;
	}
	.dzPopulateData.renault {
		background-color:#fbf9d9;
	}
	.dzPopulateData.dacia {
		background-color:#e1e4fc;
	}
.dzPopulateData.dz-clickable {
	cursor: pointer;
}
	.dzPopulateData .dz-message {
		text-align: center;
		margin: 1em 0;
	}
		.dzPopulateData.dz-started .dz-message {
			display: none;
		}
	.dzPopulateData .dz-preview {
		display: block;
		padding: 5px 0 5px 0;
	}
	.dzPopulateData .dz-preview .dz-image {
		display: none;
		background: none;
		width: 0;
		height: 0;
	}
	.dzPopulateData .dz-preview {
		display: block;
		position: relative;
		padding-bottom: 26px;
	}
	.dzPopulateData .dz-preview.dz-file-preview .dz-image {
		background: none;
	}
	.dzPopulateData .dz-preview .dz-details {
		background: none;
		color: #555555;
		font-size: 13px;
	}
		.dzPopulateData .dz-preview .dz-size {
			display: inline-block;
		}
		.dzPopulateData .dz-preview .dz-filename {
			display: inline-block;
		}

	.dzPopulateData .dz-preview .dz-progress {
		opacity: 1;
		z-index: 1000;
		pointer-events: none;
		height: 16px;
		width: 100%;
		background: rgba(133, 133, 133, 0.9);
		-webkit-transform: scale(1);
		border-radius: 8px;
		overflow: hidden;
		margin: 1px auto;
		position: absolute;
		bottom: 1px;
	}
	.dzPopulateData .dz-preview.dz-processing .dz-progress {
		opacity: 1;
		transition: all .2s linear;
	}
	.dzPopulateData .dz-preview.dz-complete .dz-progress {
		opacity: 0;
		transition: opacity .4s ease-in;
	}
	.dzPopulateData .dz-preview:not(.dz-processing) .dz-progress {
		animation: pulse 6s ease infinite;
	}
	.dzPopulateData .dz-preview .dz-progress .dz-upload {
		background: #333;
		background: linear-gradient(180deg,#666,#444);
		position: absolute;
		top: 0;
		left: 0;
		bottom: 0;
		width: 0;
		transition: width .3s ease-in-out;
	}
	.dzPopulateData .dz-preview.dz-error .dz-error-message {
		display: block;
	}
	.dzPopulateData .dz-preview.dz-error:hover .dz-error-message {
		opacity: 1;
		pointer-events: auto;
	}
	.dzPopulateData .dz-preview .dz-error-message {
		pointer-events: none;
		z-index: 1000;
		display: none;
		opacity: 0.8;
		transition: opacity .3s ease;
		border-radius: 8px;
		font-size: 12px;
		height: 22px;
		line-height: 21px;
		width: 100%;
		background: #be2626;
		background: linear-gradient(180deg,#be2626,#a92222);
		color: #fff;
		text-align: center;
	}
	.dzPopulateData .dz-preview .dz-error-message:after {
		content: "";
		position: absolute;
		top: -6px;
		left: 64px;
		width: 0;
		height: 0;
		border-left: 6px solid transparent;
		border-right: 6px solid transparent;
		border-bottom: 6px solid #be2626;
	}
	.dzPopulateData .dz-success-mark {
		position: absolute;
		bottom: 1px;
		left: 50%;
		-webkit-transform: translateX(-50%);
		transform: translateX(-50%);
	}
	.dzPopulateData .dz-error-message, .dzPopulateData .dz-success-mark, .dzPopulateData .dz-error-mark, .dzPopulateData .dz-remove {
		display: none;
	}
</style>


// WEBPACK FOOTER //
// src/components/PopulateDataModal.vue